import { useMutation } from "@apollo/client";
import { CircularProgress, createStyles, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField } from "@material-ui/core";
import defaultimageuser from "assets/images/defaultimageuser.svg";
import PhoneField from "components/@phone-field";
import { FadeInDownDiv } from "components/Animations/FadeInDown";
import { Button } from "ui/Button";
import { ProfileLoader } from "components/Table/Loader";
import { isValidPhoneNumberFormat } from "config/constants";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import HTTP_STATUS_CODES from "domains/Task/types/Column";
import { CompanyUser, Profile_User } from "generated/graphql";
import { useCurrentUser } from "hooks";
import { useCountryCode } from "hooks/useCurrentUser";
import moment from "moment";
import React from "react";
import "styled-components/macro";
import { ValidateEmail } from "utils";
import { UpdateCompanyUser } from "../graphql/mutations";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      position: "relative",
    },
    avatar: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      justifyItems: "center",
      marginLeft: "auto",
      marginRight: "auto",
    },
    rond: {
      height: 164,
      width: 164,
      borderRadius: "50%",
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "end",
      justifyItems: "end",
    },
    img: {
      height: 164,
      width: 164,
      marginLeft: "auto",
      marginRight: "auto",
    },
    time: {
      fontSize: 14,
    },
    infos: {
      display: "flex",
      flexDirection: "column",
      marginTop: 60,
      justifyContent: "center",
      marginLeft: "auto",
      marginRight: "auto",
    },
    buttons: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      position: "absolute",
      bottom: 10,
      width: "100%",
    },
    buttons1: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      width: "100%",
    },
    button: {
      marginTop: 10,
    },
    cancelButton:{
      backgroundColor: "#cfecf8",
      color: "#399ebf",
      marginTop: 10,
    },
    edit: {
      marginTop: "auto",
      backgroundColor: "rgba(255, 255, 255, 0.3);",
      marginLeft: "auto",
      marginRight: "auto",
      color: "#fff",
      overflow: "hidden",
      width: "100%",
      textAlign: "center",
      paddingBottom: 20,
      cursor: "pointer",
      zIndex: 20,
    },
    center: {
      display: "flex",
      justifyContent: "center",
    },
    label: {
      cursor: "pointer",
    },
  })
);
interface RightSideProps {
  user?: CompanyUser;
  loading?: boolean;
  dismiss: () => void;
  refetch: any;
  isSmallScreen?: boolean;
}
export function UpdateUser({ user = null, loading,dismiss, refetch }: RightSideProps) {
  const styles = useStyles();
  const { user: currentUser } = useCurrentUser();
  const [isCurrentUser, setIsCurrentUser] = React.useState(false);
  const ref = React.useRef(null);
  const dispatchAlert = useAlertDispatch();
  const [loadingImage, setLoadingImage] = React.useState<boolean>(false);
  const [updateUserCompagny] = useMutation(UpdateCompanyUser);
  const { text } = useText();
  const uploadUrl = process.env.REACT_APP_FILE_URL;
  const countryCode = useCountryCode();
  const [formValues, setFormValues] = React.useState<CompanyUser>(user);
  const [isFormSubmited, setFormSubmited] = React.useState(false);
  React.useEffect(() => {
    setIsCurrentUser(
      currentUser && currentUser._id !== user?._id && currentUser.company_user_profil !== Profile_User.Admin
    );
  }, [currentUser, user]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files[0]) {
      const { type } = files[0];
      if (type.indexOf("image") !== 0) {
        return dispatchAlert({
          message: "the image is not deleted",
          severity: "warning",
        });
      }
      // call api
      setLoadingImage(true);
      const image = files[0];
      const formData = new FormData();
      formData.append("file", image, `${user?._id}_${image.name}`);
      fetch(uploadUrl, { method: "POST", body: formData }).then((response) => {
        if (response.ok) {
          response.text().then((text) => {
            const url = JSON.parse(text);
            updateUserCompagny({
              variables: {
                input: { companyUser: { company_user_picture_url: url.url }, id: user?._id },
              },
            })
              .then((response) => {
                // todo
                const { code, message } = response.data.updateCompanyUser;
                if (code === 200) {
                  refetch();
                  dispatchAlert({
                    message: "your profile picture is updated",
                    severity: "success",
                  });
                } else {
                  dispatchAlert({ message, severity: "warning" });
                }
                setLoadingImage(false);
              })
              .catch(() => {
                dispatchAlert({
                  message: "Your profile picture is not updated",
                  severity: "warning",
                });
                setLoadingImage(false);
              });
          });
        }
      });
    }
  };

  const updateUserHandler = () => {
    const companyUserInput = {
      company_user_picture_url: formValues?.company_user_picture_url,
      company_user_firstname: formValues?.company_user_firstname,
      company_user_lastname: formValues?.company_user_lastname,
      company_user_job: formValues?.company_user_job,
      company_user_profil: formValues?.company_user_profil,
      company_user_phone_number: formValues?.company_user_phone_number?.replace(/(?!\+)\D/g, ""),
    };
    updateUserCompagny({
      variables: {
        input: {
          id: user?._id,
          companyUser: companyUserInput,
        },
      },
    })
      .then((response) => {
        const { message, code } = response.data.updateCompanyUser;
        if (code === HTTP_STATUS_CODES.OK) {
          refetch();
          dispatchAlert({ message: text.users.user_updated_msg, severity: "success" });
        } else {
          dispatchAlert({ message, severity: "warning" });
        }
      })
      .catch(() => {
        dispatchAlert({ message: text.users.user_not_updated_msg, severity: "warning" });
      });
  };

  const handleInputChange = React.useCallback(
    (event: any) => {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.value,
      });
    },
    [formValues]
  );
  const isValidPhone = () =>
    formValues.company_user_phone_number.length && isValidPhoneNumberFormat(formValues.company_user_phone_number);

    const handleSubmit = () => {
      setFormSubmited(true);
    if (!isValidPhoneNumberFormat(formValues?.company_user_phone_number)) return;

    if (ValidateEmail(formValues?.company_user_email) === false) return;
    // eslint-disable-next-line no-restricted-syntax
    for (const el in formValues)
      if (
        (el === "company_user_firstname" || el === "company_user_lastname" || el === "company_user_email") &&
        formValues[el]?.length === 0
      )
        return;
      updateUserHandler();
      setFormValues(user);
      dismiss();

    }

  return (
    <>
      {loading || !user ? (
        <ProfileLoader />
      ) : (
        <FadeInDownDiv className={styles.root}>
          <Grid className={styles.avatar}>
            <Grid>
              {loadingImage ? (
                <div className={styles.rond}>
                  <div
                    style={{
                      display: "flex",
                      marginTop: "auto",
                      marginBottom: "auto",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </div>
              ) : (
                <div
                  className={styles.rond}
                  style={{
                    backgroundImage: `url(${user?.company_user_picture_url ?? defaultimageuser})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  <div
                    className={styles.edit}
                    onClick={() => {
                      if (user?.company_user_profil !== Profile_User.Admin || user?._id === currentUser?._id) {
                        ref.current.click();
                      }
                    }}
                  >
                    <input
                      id="img"
                      ref={ref}
                      name="uploaded_img"
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      hidden
                      onChange={handleChange}
                    />
                    <label className={styles.label}>{text.user.edit_photo}</label>
                  </div>
                </div>
              )}
            </Grid>
            <Grid item xs={12} className={styles.time}>
              {text.all.last_connexion}
              {user?.company_user_last_active ? moment(user?.company_user_last_active).fromNow() : "never"}
            </Grid>
          </Grid>
          <Grid style={{marginTop: 5}} container spacing={4} >
          <Grid item xs={12}>
          <TextField
          variant="outlined"
            fullWidth
            label={text.all.email}
            name="company_user_email"
            value={formValues.company_user_email}
            disabled={formValues.company_user_email === user?.company_user_email}
            onChange={handleInputChange}
            error={
              isFormSubmited &&
              (formValues?.company_user_email?.length === 0 || ValidateEmail(formValues?.company_user_email) === false)
            }
            helperText={
              isFormSubmited &&
              (formValues?.company_user_email?.length === 0 || ValidateEmail(formValues?.company_user_email) === false)
                ? `${text.all.this_field_is_required}`
                : ""
            }
            required
          />
        </Grid>
        <Grid item  xs={12}>
          <TextField
          variant="outlined"
            fullWidth
            label={text.all.first_name}
            name="company_user_firstname"
            value={formValues.company_user_firstname}
            onChange={handleInputChange}
            error={isFormSubmited && formValues?.company_user_firstname?.length === 0}
            helperText={
              isFormSubmited && formValues?.company_user_firstname?.length === 0
                ? `${text.all.this_field_is_required}`
                : ""
            }
            required
          />
        </Grid>
        <Grid item  xs={12}>
          <TextField
          variant="outlined"
            fullWidth
            label={text.all.last_name}
            name="company_user_lastname"
            value={formValues.company_user_lastname}
            onChange={handleInputChange}
            error={isFormSubmited && formValues?.company_user_lastname?.length === 0}
            helperText={
              isFormSubmited && formValues?.company_user_lastname?.length === 0
                ? `${text.all.this_field_is_required}`
                : ""
            }
            required
          />
        </Grid>

        <Grid item xs={12}>
          <PhoneField
            countryCode={countryCode}
            fullWidth
            label={text.all.phone_number}
            name="company_user_phone_number"
            value={formValues.company_user_phone_number}
            type="tel"
            onValueChange={(value) => {
              setFormValues({
                ...formValues,
                company_user_phone_number: value,
              });
            }}
            error={isFormSubmited && !isValidPhone()}
            helperText={isFormSubmited && !isValidPhone() ? `${text.all.not_valid_format}` : ""}
            required
          />
        </Grid> 
        <Grid item  xs={12}>
        <FormControl
            variant="outlined"
            fullWidth
            error={isFormSubmited && formValues?.company_user_profil?.length === 0}
            required
          >
            <InputLabel id="demo-simple-select-outlined-label">{text.user.user_role}</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={user.company_user_profil}
              label={text.user.user_role}
              name="company_user_profil"
              onChange={handleInputChange}
              disabled={user?.company_user_profil === Profile_User.Simple}
            >
              <MenuItem value={Profile_User.Simple}>SIMPLE</MenuItem>
              <MenuItem value={Profile_User.Admin}>ADMIN</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
          
          <Grid container spacing={2} style={{marginTop: 5}}>
          <Grid item xs={6}>
              <Button className={styles.cancelButton} variant="contained" fullWidth
              onClick={dismiss}
              >
                {text.all.cancel}</Button>
            </Grid>
            <Grid item xs={6}>
            <Button
              className={styles.button}
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              disabled={isCurrentUser}
              fullWidth
            >
              {text.all.update}
            </Button>
            </Grid>
          </Grid>
        </FadeInDownDiv>
      )}
    </>
  );
}

